import { render } from "./CaixaCliente.vue?vue&type=template&id=55075628&scoped=true&ts=true"
import script from "./CaixaCliente.vue?vue&type=script&lang=ts"
export * from "./CaixaCliente.vue?vue&type=script&lang=ts"

import "./CaixaCliente.vue?vue&type=style&index=0&id=55075628&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55075628"]])

export default __exports__